import { createTheme } from "@mui/material/styles";
import { orange } from "@mui/material/colors";
import { fontWeight } from "@mui/system";

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: string;
    };
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    spacing: number;
    styleOverrides?: {
      html?: {};
      body?: {};
    };
    status?: {
      danger?: string;
    };
    body?: {};
  }
}

export const theme = createTheme({
  palette: {
    background: {
      default: "#0F3151",
    },
    text: {
      primary: "#fff",
      secondary: "#C7D4DB",
    },
    primary: {
      main: "#2A5E7B",
      light: "#7F9EAF",
      dark: "#0F3151",
      contrastText: "#0F3151",
    },
    secondary: {
      main: "#65ECEC",
      light: "#48A5B3",
      contrastText: "#C7D4DB",
    },
    error: {
      main: "#FFB6B6",
      dark: "#FF5A5A",
    },
  },
  spacing: 4,
  status: {
    danger: orange[500],
  },
  typography: {
    fontFamily: ["Inter", "Manrope", "Roboto", "sans-serif"].join(","),
    body1: {
      color: "#C7D4DB",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body, #root, #root > div {
          height: 100%;
        }

        html {
          height: 100%;
        }

        a {
          color: #7F9EAF
        }

        a {
          color: white;
          text-decoration: none;
        }

        input {
          padding: 24px;
          border: 3px solid #48A5B3;
          border-radius: 16px
        }

        img {
          height: inherit;
        }
        
      `,
    },
    MuiSelect: {
      styleOverrides: {
        ...{
          root: {
            height: "68px",
            // paddingRight: "28px",
            border: "3px solid #48A5B3",
            borderRadius: "16px",
          },
          nativeInput: {
            padding: "22px 24px 22px 24px",
            borderRadius: "16px",
          },
          iconOpen: {
            transform: "rotate(180deg)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          input: {
            "&:-webkit-autofill": {
              transition: "background-color 0s 600000s, color 0s 600000s",
              WebkitBoxShadow: "0 0 0px 1000px transparent inset",
            },
          },
        },
        notchedOutline: {
          border: "none",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "#65ECEC",
          fontWeight: 700,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          lineHeight: 1.28,
        },
        body1: {
          fontWeight: 500,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: "0px 9px",
        },
      },
    },
  },
});
